import React from 'react'
import AccountTypePage from './AccountTypePage'

export default function EcnAccount() {
  return (
    <AccountTypePage
      name="ECN"
      tagline="Raw spreads plus a transparent per-side commission, built for active traders."
      description={[
        'The ECN account passes through raw market spreads, as low as 0.0 pips, with a fixed commission charged per lot per side. This structure gives you full visibility into what you are paying for execution.',
        'With deep liquidity, tight spreads, and fast order execution, the ECN account suits day traders, scalpers, and anyone who wants transparent, competitive pricing.',
      ]}
      spec={[
        { label: 'Asset Classes', value: 'Forex, Metals, Energies, Indices, Crypto' },
        { label: 'Spreads From', value: '0.0 pips' },
        { label: 'Commission', value: '$3.5 / lot per side' },
        { label: 'Leverage up to', value: '1:1000' },
        { label: 'Minimum Deposit', value: '$500' },
        { label: 'Minimum Trade Size', value: '0.01 lots' },
        { label: 'Maximum Total Trade Size', value: 'Unlimited' },
        { label: 'Maximum Single Order Size', value: '50 lots' },
        { label: 'Account Currency', value: 'USD, USDT' },
        { label: 'Order Execution', value: 'Market' },
        { label: 'Margin Call', value: '50%' },
        { label: 'Stop Out', value: '30%' },
        { label: 'Negative Balance Protection', value: 'Yes' },
      ]}
      switchTo={[
        { label: 'STD', to: '/trading/std-account' },
        { label: 'PRO', to: '/trading/pro-account' },
      ]}
    />
  )
}
